export const Wordmark = ({ className = "", size = "text-xl", testid = "wordmark" }) => (
  <span data-testid={testid} className={`inline-flex items-center ${className}`}>
    <span className="mr-2.5 flex flex-col justify-center gap-[3px]" aria-hidden="true">
      <span className="block h-[2.5px] w-7 -skew-x-[24deg] bg-gold shadow-[0_0_8px_rgba(201,168,76,0.8)]" />
      <span className="block h-[2px] w-5 -skew-x-[24deg] bg-gold/80 shadow-[0_0_6px_rgba(201,168,76,0.7)]" />
      <span className="block h-[1.5px] w-3.5 -skew-x-[24deg] bg-gold/60 shadow-[0_0_5px_rgba(201,168,76,0.6)]" />
    </span>
    <span className={`${size} font-heading font-bold uppercase leading-none tracking-tight`}>
      <span className="text-white">God</span>
      <span className="gold-glow-text text-gold">speed</span>
    </span>
  </span>
);
